module.exports = __webpack_public_path__ + "static/media/vin_windshield.7d303597.jpg";